import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { AssetCategory } from 'src/app/models/asset-category';
import { MessageEventService } from 'src/app/util/message-event.service';
import { ReactiveSingletonEntityEditPageComponent } from 'src/app/util/reactive-singleton-entity-edit-page.base';
import { HomesickCategories, Organization } from '../../../models/organization';
import {
  AdditionalFormData,
  OrganizationForm,
  OrganizationFormService,
} from '../../organization-form.service';
import { OrganizationsService } from '../../organizations.service';

@Component({
  selector: 'app-organization-edit',
  templateUrl: './organization-edit.component.html',
  styleUrls: ['./organization-edit.component.scss'],
  providers: [OrganizationFormService],
})
export class OrganizationEditComponent
  extends ReactiveSingletonEntityEditPageComponent<
    Organization,
    OrganizationForm,
    AdditionalFormData
  >
  implements OnInit, OnDestroy
{
  constructor(
    organizationsService: OrganizationsService,
    messageService: MessageEventService,
    router: Router,
    titleService: Title,
    orgFormService: OrganizationFormService,
    private fb: FormBuilder
  ) {
    super(
      organizationsService,
      messageService,
      router,
      titleService,
      orgFormService
    );
  }

  // Title and navigation configs
  protected getEntityUpdatedMessage(entity: Organization): string {
    return `Organization '${entity.name}' updated`;
  }
  protected getPostEditRoute(updatedEntity: Organization): string[] {
    return ['/organization'];
  }
  protected getBaseTitle(): string {
    return 'Edit Organization';
  }
  protected getTitle(entity: Organization): string {
    return `Edit ${entity.name}`;
  }
  protected cancelEdit() {
    this.router.navigate(['organization']);
  }

  // How to load the organization into the form
  protected handleLoadedFormData(entity: Organization) {
    this.loadCategories(entity.homesick_categories);
    this.form.patchValue({
      name: entity.name,
      street_address: entity.street_address,
      street_address2: entity.street_address2,
      city: entity.city,
      country: entity.country,
      region: entity.region,
      postal_code: entity.postal_code,
      discover_locations: entity.discover_locations,
      default_homesick_days: entity.default_homesick_days,
      any_fixed_is_home: entity.any_fixed_is_home,
    });
  }

  loadCategories(orgCategories?: HomesickCategories) {
    const homesickControl = this.form.controls.homesick_categories;
    if (!orgCategories || Object.keys(orgCategories).length === 0) {
      homesickControl.patchValue([]);
      return;
    }
    // Get categories from service
    this.formService.additionalFormData$
      .pipe(map(({ categories }) => categories))
      .subscribe((categories: AssetCategory[]) => {
        // Get the name for each organization category and push the object to the form array
        Object.entries(orgCategories).forEach(([id, length]) => {
          const category = categories.find(
            (orgCategory) => id === orgCategory.id
          );
          homesickControl.push(
            this.fb.group({
              id,
              length,
              name: category.name,
            })
          );
        });
      });
  }
}
